import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import AddCardModal from "../Billing/AddCardModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const PublishModal = ({ show, handleClose, chatId, fetchActions, context }) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");

    const [loading, setLoading] = useState(false);
    const [loadingInfo, setLoadingInfo] = useState(true)
    const [error, setError] = useState({ message: "", display: false });
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [hasPayment, setPayments] = useState(false);
    const [cardModal, openCardModal] = useState(false)

    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setTitle(null)
        setDescription(null)
    };

    const test_stripe = "pk_test_51RU6Q7GwIOZks56fh1QyjQfqeNQNG6XuqAhKUujCKuJzrd4t45toMk7F58pN2Qrb2mtMVd0GGwIyIE2YjTjKJUxa00RjClmNw8"
    const prod_stripe = "pk_live_51RU6Q7GwIOZks56fg4G48srkSo7NqKfnDemTYJwmJKJug0tFjLkivLHBRTjtzTIQKc0fsTmvbRtvHdx0Zj5AuzsA00o6ZnIc6L"
    const stripePromise = loadStripe(test_stripe);

    const fetchUserData = async () => {
        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id }),
            });

            if (!response.ok) throw new Error('Failed to fetch user data');

            const data = await response.json();
            setPayments(!!data.payment_method);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {

        }
    };


    const startDeployment = async () => {
        try {
            setLoading(true);
            const response = await fetch("https://aiservice.erioon.com/start_deployment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, project_id, chatId, title, description, context }),
            });

            if (response.ok) {
                const result = await response.json();
            } else {
                throw new Error("Failed to start deployment");
            }
        } catch (err) {
            setError({ message: "Failed to start deployment.", display: true });
        } finally {
            setLoading(false);
            fetchActions()
            CloseModal()
        }
    };

    const getTitleDescription = async () => {
        setLoadingInfo(true)
        try {
            const response = await fetch("https://aiservice.erioon.com/get_title_description_codebase", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, project_id }),
            });

            if (response.ok) {
                const result = await response.json();
                if (result.title) setTitle(result.title);
                if (result.description) setDescription(result.description);
            }
        } catch (err) {
            setLoadingInfo(false)
        } finally {
            setLoadingInfo(false)
        }
    };

    useEffect(() => {
        if (show) {
            getTitleDescription();
            fetchActions()
            fetchUserData()
        }
    }, [show, project_id]);



    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">

            <div className="share_main_cont_modal">
                <p className="share_label">Publish project</p>
                <p className="share_label_desc">
                    Launch your app to the web so others can view and interact with it.
                </p>



                {loadingInfo ? (
                    <div className="loading_rules_cont fade-in">
                        <div className="loading_rules_cont_title"></div>
                        <div className="loading_rules_cont_body"></div>
                    </div>

                ) : (
                    <>
                        {!hasPayment && (
                            <div className="no_card fade-in" onClick={() => openCardModal(true)}>
                                <p>No card available</p>
                                <button className="add_card_btn">Add new card</button>
                            </div>
                        )}

                        <label className="deployment_section_title fade-in">Title</label>
                        <div className="label_input_section fade-in">
                            <input
                                placeholder="Set project title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <label className="deployment_section_title fade-in">Description</label>
                        <div className="label_input_section fade-in">
                            <textarea
                                className="description_area_input"
                                placeholder="Enter project description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                        {/* 
                        <div className="actions_container_ai">
                            <p className="actions_container_ai_title">Live actions</p>
                            {actions.map((actionText, i) => {
                                return (
                                    <div className="single_action_card fade-in"
                                        dangerouslySetInnerHTML={{ __html: actionText }}></div>
                                );
                            })}

                        </div> */}


                    </>
                )}

            </div>
            {hasPayment && (
                <div className="modal_footer">
                    <ErrorMessage err={error} />
                    <div className="footer_btn_cont">
                        <button className="save_btn" onClick={startDeployment} disabled={loading}>
                            {loading ? <Spinner loading={loading} /> : "Publish"}
                        </button>
                        <button className="cancel_btn" onClick={CloseModal}>
                            {t.cancel}
                        </button>
                    </div>
                </div>
            )}
            <Elements stripe={stripePromise}>
                <AddCardModal show={cardModal} handleClose={() => openCardModal(false)} fetchBilling={fetchUserData} />
            </Elements>
        </Modal>
    );
};

export default PublishModal;
